import buildResourceReducer from 'store/configure/reducers'

import actions from './actions'

export default buildResourceReducer(actions)
